import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { FONT_WEIGHT_MEDIUM, FONT_WEIGHT_REGULAR } from '../../../styles/rn';
var Styles = CustomStyleSheet({
  'delivery-card': {
    width: '100%',
    backgroundColor: '#ffffff'
  },
  'delivery-card-head': {
    padding: 10,
    flexDirection: 'row',
    borderBottomColor: 'rgba(0, 0, 0, 0.09)',
    borderBottomWidth: 0.5
  },
  'delivery-card-head-icon': {
    width: 20,
    height: 20,
    marginRight: 6
  },
  'delivery-card-head-title': _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 16,
    lineHeight: 20,
    color: 'rgba(0, 0, 0, 0.87)',
    flex: 1
  }),
  'delivery-card-detail': _objectSpread(_objectSpread({}, FONT_WEIGHT_REGULAR), {}, {
    margin: 10,
    marginTop: 0,
    padding: 8,
    borderRadius: 8,
    backgroundColor: '#F5F5F5'
  }),
  'delivery-card-detail-title': _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
    color: '#EE4D2D',
    fontSize: 14,
    lineHeight: 16
  }),
  'delivery-card-detail-content': {
    color: 'rgba(0, 0, 0, 0.87)',
    paddingTop: 4,
    fontSize: 14,
    lineHeight: 16
  }
});
export default Styles;